$(document).ready(function () {
    $('.btn-login').on('click', function () {
       $this = $(this);
       $this.addClass('disabled');
       $this.attr('disabled', 'disabled');
       $this.text("");
       $this.html("<i class=\"mdi mdi-autorenew mdi-spin mdi-24px\"></i> ");
       $('.login-form').submit();
    });

    $(document).on('click', '.btn-load', function () {
        $(this)
            .find('i.mdi').removeClass (function (index, className) {
            return (className.match (/(^|\s)mdi-\S+/g) || []).join(' ');
        })
            .prepend("<i class=\"mdi mdi-autorenew mdi-spin\"></i> ")
            .addClass('disabled')
        ;
    });

    $(document).on('change', 'input[name="iban"]', function () {
        $.post($(this).data('route'), {iban: $(this).val()}, function (data) {
                if(data.valid === true) {
                    $('input[name="bic"]').val(data.bankData.bic);
                }
            }
        );
    });

    $(document).on('change', 'select[name="server"]', function () {
        $.post($(this).data('route'), {serverId: $(this).val()}, function (data) {
                let dropdown = $('select[name="client"]');
                dropdown.empty();
                $.each(data, function (key, entry) {
                    dropdown.append($('<option></option>').attr('value', entry.username).text(entry.username));
                })
            }
        );
    });
});

import * as SignaturePad from 'signature_pad/dist/signature_pad.min';

var canvas = document.getElementById('signature-pad');
if(canvas !== null) {

    // Adjust canvas coordinate space taking into account pixel ratio,
    // to make it look crisp on mobile devices.
    // This also causes canvas to be cleared.
    function resizeCanvas() {
        // When zoomed out to less than 100%, for some very strange reason,
        // some browsers report devicePixelRatio as less than 1
        // and only part of the canvas is cleared then.
        var ratio =  Math.max(window.devicePixelRatio || 1, 1);

        if(canvas !== null) {
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext("2d").scale(ratio, ratio);
        }
    }

    window.onresize = resizeCanvas;
    resizeCanvas();

    var signaturePad = new SignaturePad(canvas, {
        backgroundColor: 'rgb(255, 255, 255)' // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
    });

    document.getElementById('save-action').addEventListener('click', function (event) {
        if (signaturePad.isEmpty()) {
            return alert("U moet eerst een handtekening zetten.");
        }
        var data = signaturePad.toDataURL('image/png');
        $('input[name="signature"]').val(data);

    });

    document.getElementById('clear').addEventListener('click', function () {
        signaturePad.clear();
    });
}
